import gql from 'graphql-tag';

export const LISTING_SS_FRAGMENT = gql`
    fragment LISTING_SS_FRAGMENT on Listing {
        listingId
        price
        priceTitle
        shortPriceTitle
        alternativeRentFrequencyLabel
        priceDrop {
            lastPriceChangeDate
            percentageChangeLabel
        }
        branch {
            branchDetailsUri
            branchId
            logoUrl
            name
            phone
        }
        title
        address
        publishedOnLabel
        publishedOn
        availableFrom
        tags {
            content
        }
        features {
            content
            iconId
        }
        image {
            src
            caption
            responsiveImgList {
                width
                src
            }
        }
        flag
        transports {
            distanceInMiles
            lat
            lng
            poiType
            title
            features {
                tubeLines
                zone
            }
        }
        isNewHomesDevelopment
        isPremium
        otherPropertyImages {
            small
            large
            caption
        }
        highlights {
            description
            label
            url
        }
        displayType
        numberOfVideos
        numberOfViews
        numberOfImages
        numberOfFloorPlans
        FloatOfVideos
        FloatOfImages
        FloatOfFloorPlans
        listingUris {
            contact
            detail
            success
        }
        featuredType
        location {
            coordinates {
                isApproximate
                latitude
                longitude
            }
            postalCode
            countryCode
            county
            streetName
            propertyNumberOrName
            townOrCity
        }
        section
        publicationStatus
        lastPublishedDate
        propertyType
        summaryDescription
    }
`;
